import genericsFn from '../../styles/generics/styles'

export default genericsFn



// WEBPACK FOOTER //
// ./containers/resume/styles.js